<template>
  <div class="integral">
    <div class="top">
      <div class="num">{{account.point}}</div>
      <div class="tit">累计积分</div>
      <router-link :to="{ name: 'integralexplanation' }" class="alink">积分说明</router-link>
    </div>
    <div class="app-num-list topline">
      <div class="bigtit">积分变动记录</div>

      <div v-if="list.length > 0" class="weui-cells">
          <div v-for="(v,k) in list" v-bind:key="k" class="weui-cell">
              <div class="weui-cell__bd">
                  <p class="tit">{{v.note}}</p>
                  <p class="time">{{v.updated_at}}</p>
              </div>
              <div class="weui-cell__ft num" :class="[v.point>=0?'add':'minus']">{{v.point}}</div>
          </div>
      </div>
      <div v-else class="nodata">暂无数据</div>
    </div>

    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10"></div>
  </div>
</template>

<script>
import infiniteScroll from '@/basic/infiniteScroll'
export default {
  directives: {infiniteScroll},
  data(){
    return{
      account:{},
      list:[],
      busy: true,
      load:true,
      page:1
    }
  },
  mounted() {
    this.getAccount();
    this.getAccountPointLog()
  },
  methods:{
    getAccount(){
      let vm = this;
      vm.ajax("account", "get", '', e => {
        vm.account = e.data;
      })
    },
    getAccountPointLog(flag){
      let vm = this;
      vm.ajax("account/point/log", "get", 'page='+vm.page, e => {
        vm.load = false;
        if(e.data.list){
          if(flag){
            vm.list =  vm.list.concat(e.data.list)
            if(e.data.count == vm.page){
                vm.busy = true;
            }else{
                vm.busy = false;
            }
          }else{
            vm.list =  e.data.list;
            if(vm.list.length < e.data.limit){
              vm.busy = true;
            }else{
              vm.busy = false;
            }
          }
        }else{
          vm.busy = true;
        }
      })
    },
    loadMore() {
      let vm = this;
      vm.busy = true;
      vm.load = true;
      setTimeout(() => {
          vm.page++;
          vm.getAccountPointLog(true);
      }, 1000);
    }
  }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/integral.vue